import React, { useState, useEffect } from "react";
import Axios from "axios";
import "./../../../../assets/css/purchase/form.css";

// React DateTime
import Datetime from "react-datetime";
import moment from "moment";

// Components
import Breadcrumbs from "../../../components/Breadcrumbs";
import CloseVansaleForAccountModal from "../../../components/Modal/CloseVansaleForAccountModal";
import ArModal from "../../../components/Modal/ArModal";
import DeliveryModal from "../../../components/Modal/DeliveryModal";
import ImportModal from "../../../components/Modal/ImportModal";
import TeasuryTable from "../../../components/Content/TeasuryTable";
import ViewSoModal from "../../../components/Modal/ViewSoModal";
import FormAction from "../../../components/Actions/FormAction";

// Model
import { pkListMasterModel } from "../../../../model/SellProducts/PkListMasterModel";
import { pkListDetailModel } from "../../../../model/SellProducts/PkListDetailModel";

// Utils
import {
  getDataWithComp,
  deleteData,
  getMaxDocNo,
  getMaxWdNo,
  getSoWithoutPK,
  getAlert,
  getData,
  formatCurrency,
  randomDelay,
  parseCurrency,
} from "../../../../utils/SamuiUtils";

import {
  formatDate,
  formatStringDateToDate,
  formatDateOnChange,
  formatThaiDateUi,
  formatThaiDateUiToDate,
  getCreateDateTime,
  setCreateDateTime,
} from "../../../../utils/DateUtils";

import { manageWhItemData } from "../../../../utils/WarehouseUtils";
import CloseVansaleForWarehouseModal from "../../../components/Modal/CloseVansaleForWarehouseModal";
import { ExportVansaleSalesReport } from "../../../../utils/ExportUtils";

function Form({
  callInitialize,
  mode,
  name,
  maxDocNo,
  onRowSelected,
  getReport,
}) {
  const [formMasterList, setFormMasterList] = useState(pkListMasterModel());
  const [formDetailList, setFormDetailList] = useState([]);
  const [formWdList, setFormWdList] = useState([]);
  const [arDataList, setArDataList] = useState([]);
  const [soDataList, setSoDataList] = useState([]);
  const [dlLineList, setDlLineList] = useState([]);

  // รายละเอียดการส่งสินค้า & ใบขาย
  const [soListData, setSoListData] = useState([]);
  const [itemList, setItemList] = useState([]);

  // รถส่งสินค้า
  const [carList, setCarList] = useState([]);

  // คนขับรถส่งสินค้า
  const [driverList, setDriverList] = useState([]);

  // การแสดงสถานะใบ
  const [docStatus, setDocStatus] = useState(null);
  const [statusName, setStatusName] = useState("");
  const [statusColour, setStatusColour] = useState("");
  const [reqStcStatusName, setReqStcStatusName] = useState("");
  const [reqStcStatusColour, setReqStcStatusColour] = useState("");
  const [dlLineName, setDlLineName] = useState("");

  // ตัวแปรประเภทการดึงข้อมูลจาก DeliveryModal (SO = ใบขาย, DL = สายส่ง)
  const [selectedType, setSelectedType] = useState("");

  // การใช้ Tab เพื่อเปลี่ยน Form
  const [activeTab, setActiveTab] = useState("deliveryDetails");

  // ใช้สำหรับเก็บค่าสูงของ WD (ใบเบิก)
  const [maxWdNo, setMaxWdNo] = useState();

  // ใช้สำหรับแสดงสินค้าคงคลัง
  const [selectedWarehouseCode, setSelectedWarehouseCode] = useState("");
  const [formItemOnHandCaseTab, setFormItemOnHandCaseTab] = useState([]);
  const [formItemWithdrawCaseTab, setFormItemWithdrawCaseTab] = useState([]);

  // เก็บค่าของสายส่งไว้หลังบันทึกเสร็จ
  const [deliveryLineId, setDeliveryLineId] = useState(null);

  // เก็บค่าสำหรับ onLoad เมื่อกดยืนยันการนำเข้า
  const [selectedImports, setSelectedImports] = useState([]);
  const [onLoadConfirm, setOnLoadConfirm] = useState(false);

  // สำหรับเปิดสลิปเงินโอน
  const [showSlipModal, setShowSlipModal] = React.useState(false);

  // สำหรับ Freeze หน้าจอตอนทำรายการ
  const [isLoading, setIsLoading] = useState(false);

  // สำหรับค้นหาลูกค้า
  const [searchCustomer, setSearchCustomer] = useState('');

  useEffect(() => {
    initialize();
  }, []);

  // รอบให้ Default ตามเวลาปัจจุบัน แต่ยังคงให้เลือกได้อยู่ แค่ Default เฉยๆ (รอพี่แบงค์ทดสอบ)
  // => เช้า 06:00 - 11:59
  // => บ่าย 12:00 - 17:59
  // => ค่ำ 18:00 - 05:59
  useEffect(() => {
    const currentHour = new Date().getHours();
    let round;

    if (currentHour >= 6 && currentHour < 12) {
      round = "1"; // 1 = รอบเช้า (อ้างอิงจาก PKList_H)
    } else if (currentHour >= 12 && currentHour < 18) {
      round = "2"; // 2 = รอบบ่าย (อ้างอิงจาก PKList_H)
    } else {
      round = "3"; // 3 = รอบค่ำ (อ้างอิงจาก PKList_H)
    }

    setFormMasterList((prevState) => ({
      ...prevState,
      pkRound: round,
    }));
  }, []);

  const initialize = async () => {
    try {
      // สำหรับ Freeze หน้าจอตอนทำรายการ
      setIsLoading(true);

      const arDataList = await getDataWithComp(
        "Tb_Set_AR",
        "ORDER BY AR_Code ASC"
      );
      if (arDataList && arDataList.length > 0) {
        setArDataList(arDataList);
      }

      const soDataList = await getSoWithoutPK();
      if (soDataList && soDataList.length > 0) {
        setSoDataList(soDataList);
      }

      const dlDataList = await getDataWithComp(
        "DL_Line_H",
        "ORDER By DL_Id ASC"
      );
      if (dlDataList && dlDataList.length > 0) {
        setDlLineList(dlDataList);
      }

      // หาค่าสูงของ WHDocNo ใน WHDOC_H สำหรับ WD (ใบเบิก)
      const findMaxWdNo = await getDataWithComp(
        "WHDoc_H",
        `AND WHDoc_Type = '3' ORDER BY WHDoc_No DESC`
      );
      const maxWd = getMaxWdNo(findMaxWdNo);
      setMaxWdNo(maxWd);

      // สำหรับ View เข้ามาเพื่อแก้ไขข้อมูล
      if (mode === "U") {
        await getModelByNo();
      }

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.message);
    }
  };

  const getModelByNo = async () => {
    try {
      const findMaster = await getDataWithComp("PKList_H", ``);
      const fromDatabase = findMaster.find((pk) => pk.Doc_No === maxDocNo);

      if (!fromDatabase) {
        setIsLoading(false);
        throw new Error("ไม่พบข้อมูลเอกสาร");
      }

      // ค้นหาข้อมูล VIEW
      const findViewMaster = await getDataWithComp("API_0801_PKList_H", "");
      const fromView = findViewMaster.find((data) => data.Doc_No === maxDocNo);
      setDocStatus(fromView.Doc_Status);
      setStatusName(fromView.DocStatus_Name);
      setStatusColour(fromView.DocStatus_Colour);
      setReqStcStatusName(fromView.RequestSTCStatus_Name);
      setReqStcStatusColour(fromView.RequestSTCStatus_Colour);
      setDlLineName(fromView.DL_LineName);

      // ค้นหาข้อมูลของ Detail ด้วย Doc_ID
      const fromViewDetail = await getData(
        "API_0802_PKList_D",
        `Doc_Id = ${fromDatabase.Doc_Id} ORDER BY DL_Queue ASC`
      );

      const getSoByDocNo = async (soId) => {
        if (soId === null || soId === undefined) {
          return null;
        }

        const viewSo = await getData("API_0701_SO_H", `Doc_ID = ${soId}`);
        return String(viewSo?.[0]?.Doc_No ?? '');
      };

      // 1 จากใบขาย || 2 จากสายส่ง
      if (parseCurrency(fromDatabase.PKDoc_Type) === 1) {
        // ใบขาย
        setSelectedType("SO");
        setFormDetailList([]);

        const updatedFormDetails = await Promise.all(
          fromViewDetail.map(async (data) => ({
            docId: data.Doc_Id,
            dlQueue: data.DL_Queue,
            arId: data.AR_Id,
            arCode: data.AR_Code,
            arName: data.AR_Name,
            soId: data.SO_Id,
            docNo: await getSoByDocNo(data.SO_Id),
          }))
        );

        setFormDetailList(updatedFormDetails);

        await fetchCarAndDriverList(null);
      } else if (parseCurrency(fromDatabase.PKDoc_Type) === 2) {
        // สายส่ง
        setSelectedType("DL");
        setFormDetailList([]);

        const updatedFormDetails = await Promise.all(
          fromViewDetail.map(async (data) => ({
            docId: data.Doc_Id,
            dlQueue: data.DL_Queue,
            arId: data.AR_Id,
            arCode: data.AR_Code,
            arName: data.AR_Name,
            soId: data.SO_Id,
            docNo: await getSoByDocNo(data.SO_Id),
          }))
        );

        setFormDetailList(updatedFormDetails);

        await fetchCarAndDriverList(fromDatabase.Delivery_Line_Id);
      } else {
        setIsLoading(false);
        getAlert(
          "FAILED",
          "ไม่พบประเภทข้อมูลอ้างอิงเอกสาร กรุณาลองใหม่อีกครั้ง"
        );
      }

      setFormMasterList({
        docId: fromDatabase.Doc_Id,
        compId: fromDatabase.Comp_Id,
        docNo: fromDatabase.Doc_No,
        docDate: formatThaiDateUi(fromDatabase.Doc_Date || null),
        docStatus: fromDatabase.Doc_Status,
        reqStcStatus: fromDatabase.Request_STC_Status,
        deliveryLineId: fromDatabase.Delivery_Line_Id,
        pkCarId: fromDatabase.PK_Car_Id,
        pkCarNo: fromDatabase.PK_Car_No,
        pkRound: String(fromDatabase.PK_Round),
        pkDriver1Id: fromDatabase.PK_Driver1_Id,
        pkDriver2Id: fromDatabase.PK_Driver2_Id,
        pkDriver3Id: fromDatabase.PK_Driver3_Id,
        createdDate: setCreateDateTime(fromDatabase.Created_Date || null),
        createdByName: fromDatabase.Created_By_Name,
        createdById: fromDatabase.Created_By_Id,
        updateDate: getCreateDateTime(),
        updateByName: window.localStorage.getItem("name"),
        updateById: window.localStorage.getItem("emp_id"),
        cancelDate: setCreateDateTime(fromDatabase.Cancel_Date || null),
        cancelByName: fromDatabase.Cancel_By_Name,
        cancelById: fromDatabase.Cancel_By_Id,
        pkDocType: fromDatabase.PKDoc_Type,
      });

      // เรียกใช้ฟังชั่นดึงข้อมูลสินค้าคงเหลือ
      setSelectedWarehouseCode(fromDatabase.PK_Car_No);
      await onLoadOnHandCaseTab(fromDatabase.PK_Car_No);
    } catch (error) {
      getAlert("FAILED", error.message || error);
    }
  };

  // API_1101_WH_ITEM_ONHAND (สินค้าคงคลัง)
  const onLoadOnHandCaseTab = async (whCode) => {
    try {
      // เคลียค่าว่างทุกครั้ง
      setFormItemOnHandCaseTab([]);

      if (whCode != null) {
        const itemOnHandCaseTab = await getDataWithComp(
          "API_1101_WH_ITEM_ONHAND",
          `AND WH_Code = '${whCode}' ORDER BY Item_Code ASC`
        );

        if (itemOnHandCaseTab && itemOnHandCaseTab.length > 0) {
          // กรองข้อมูลที่ Item_Onhand มีค่าเป็น 0 หรือน้อยกว่า 0
          const filteredItems = itemOnHandCaseTab.filter(
            (item) => item.Item_Onhand > 0
          );
          setFormItemOnHandCaseTab(filteredItems);
        }
      }
    } catch (error) {
      getAlert("FAILED", error.message);
      setFormItemOnHandCaseTab([]);
    }
  };

  const onLoadWithdrawCaseTab = async (selectedImports) => {
    try {
      // เคลียค่าข้อมูลสินค้าใน state ทุกครั้ง
      setFormItemWithdrawCaseTab([]);

      if (selectedImports && selectedImports.length > 0) {
        for (const importData of selectedImports) {
          // เรียกข้อมูลสินค้า
          let itemWd = await getDataWithComp(
            "API_1002_WHDOC_D",
            `AND WHDoc_Id = ${importData.WHDoc_Id} ORDER BY Line ASC`
          );

          // ถ้ามีสินค้าให้เพิ่มเข้าไปใน state ทีละชุด
          if (itemWd && itemWd.length > 0) {
            setFormItemWithdrawCaseTab((prevItems) => [
              ...prevItems,
              ...itemWd,
            ]);
          }
        }
      }
    } catch (error) {
      getAlert("FAILED", error.message);
      setFormItemOnHandCaseTab([]); // แก้เงื่อนไขตอนเกิด error
    }
  };

  const handleSubmit = async () => {
    try {
      // สำหรับ Freeze หน้าจอตอนทำรายการ
      setIsLoading(true);

      // ทดสอบหน่วงเวลาก่อนบันทึก (ทดสอบป้องกันการซ้ำของ Doc_No)
      await randomDelay();

      // หาค่าสูงของ DocNo ใน PKList_H ก่อนบันทึก
      const findMaxDocNo = await getDataWithComp(
        "PKList_H",
        "ORDER BY Doc_No DESC"
      );
      const maxDoc = getMaxDocNo(findMaxDocNo, "PK");
      let newMaxDoc = maxDoc;

      // ตรวจสอบว่า formMasterList ต้องระบุรอบด้วย
      if (formMasterList.pkRound === null || formMasterList.pkRound === "") {
        setIsLoading(false);
        getAlert("FAILED", "กรุณาเลือกรอบ");
        return;
      }

      // ตรวจสอบว่า formDetailList มีค่าหรือมีความยาวเป็น 0
      if (!formDetailList || formDetailList.length === 0) {
        setIsLoading(false);
        getAlert("FAILED", "กรุณาเพิ่มอ้างอิงเอกสารสำหรับทำใบ Picking List");
        return; // หยุดการทำงานของฟังก์ชันหาก formDetailList ไม่มีค่า
      }

      // ตรวจสอบการเลือกรถส่งสินค้า
      if (formMasterList.pkCarId === null || formMasterList.pkCarId === "") {
        setIsLoading(false);
        getAlert("FAILED", "กรุณาเลือกรถส่งสินค้า");
        return;
      }

      // ตรวจสอบการเลือกคนขับรถส่งสินค้าอย่างน้อย 1 คน
      if (
        (formMasterList.pkDriver1Id === null ||
          formMasterList.pkDriver1Id === "") &&
        (formMasterList.pkDriver2Id === null ||
          formMasterList.pkDriver2Id === "") &&
        (formMasterList.pkDriver3Id === null ||
          formMasterList.pkDriver3Id === "")
      ) {
        setIsLoading(false);
        getAlert("FAILED", "กรุณาเลือกคนขับรถส่งสินค้าอย่างน้อย 1 คน");
        return;
      }

      // ค้นหาทะเบียนรถ
      const getCarNoByCarId = async (pkCarId) => {
        if (pkCarId === null || pkCarId === "") {
          return null;
        }
        const viewCar = await getData("Tb_Set_Car", `Car_id = ${pkCarId}`);
        return String(viewCar[0].Car_No);
      };

      // ตรวจสอบว่ารถคันนี้ที่เลือกมา ได้สร้าง Picking List ไปหรือยัง
      const checkCarExist = await getDataWithComp(
        "PKList_H",
        `AND Doc_Status IN ('1','2') AND PK_Car_Id = ${formMasterList.pkCarId}`
      );
      if (checkCarExist && checkCarExist.length > 0) {
        setIsLoading(false);
        getAlert(
          "FAILED",
          "ไม่สามารถสร้างใบ Picking List ได้ เนื่องจากรถนี้มีการสร้าง Picking List แล้ว"
        );
        return;
      }

      // ข้อมูลหลักที่จะส่งไปยัง API
      const formMasterData = {
        comp_id: window.localStorage.getItem("company"),
        doc_no: newMaxDoc,
        doc_date: formatStringDateToDate(formMasterList.docDate),
        doc_status: parseCurrency("1", 10),
        req_stc_status: parseCurrency("0", 10),
        delivery_line_id: deliveryLineId,
        pk_car_id: formMasterList.pkCarId,
        pk_car_no: await getCarNoByCarId(formMasterList.pkCarId || null),
        pk_round: parseCurrency(formMasterList.pkRound, 10),
        pk_driver_1_id: formMasterList.pkDriver1Id,
        pk_driver_2_id: formMasterList.pkDriver2Id,
        pk_driver_3_id: formMasterList.pkDriver3Id,
        created_date: formatThaiDateUiToDate(formMasterList.createdDate),
        created_by_name: window.localStorage.getItem("name"),
        created_by_id: window.localStorage.getItem("emp_id"),
        update_date: null,
        update_by_name: null,
        update_by_id: null,
        cancel_date: null,
        cancel_by_name: null,
        cancel_by_id: null,
        pk_doc_type:
          selectedType === "SO" ? 1 : selectedType === "DL" ? 2 : null,
      };

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/create-pk-list-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      // ตรวจสอบสถานะการตอบกลับ
      if (response.data.status === "OK") {
        try {
          const getDocIdResponse = await Axios.post(
            `${process.env.REACT_APP_API_URL}/api/get-by-doc-no`,
            {
              table: "PKList_H",
              doc_no: formMasterData.doc_no,
              comp_id: window.localStorage.getItem("company"),
            },
            {
              headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
            }
          );

          if (getDocIdResponse && getDocIdResponse.data.length > 0) {
            const docId = parseCurrency(getDocIdResponse.data[0].Doc_Id, 10);

            const formDetailPromises = formDetailList.map(async (item, index) => {
              const formDetailData = {
                doc_id: docId,
                dl_queue: index + 1,
                ar_id: item.arId,
                ar_code: item.arCode,
                ar_name: item.arName,
                so_id: item.soId,
              };

              // ตรวจสอบและย้าย stock ถ้ามี soId
              // if (item.soId != null) {
              //   let findDetail = await getData('SO_D', `Doc_ID = ${item.soId} ORDER BY Line ASC`);

              //   for (const soDetail of findDetail) {
              //     // ย้ายออก
              //     await manageWhItemData(
              //       soDetail.Item_Id,
              //       soDetail.Item_Code,
              //       soDetail.Item_Name,
              //       soDetail.WH_Id,
              //       "TO", // ย้ายออก
              //       parseCurrency(soDetail.Item_Qty),
              //       docId,
              //       newMaxDoc,
              //       item.docNo,
              //       null
              //     );

              //     // ดึงข้อมูลโกดังจาก Car_No สำหรับการย้ายเข้า
              //     let getWarehouseByCarNo = await getDataWithComp('Tb_Set_WH', `AND WH_Status = 'Y' AND WH_Code = '${formMasterData.pk_car_no}'`);
              //     if (getWarehouseByCarNo.length === 0) {
              //       throw new Error('ระบบไม่พบ Car_No กรุณาตรวจสอบข้อมูล');
              //     }

              //     // ย้ายเข้า
              //     await manageWhItemData(
              //       soDetail.Item_Id,
              //       soDetail.Item_Code,
              //       soDetail.Item_Name,
              //       getWarehouseByCarNo[0].WH_Id,
              //       "TI", // ย้ายเข้า
              //       parseCurrency(soDetail.Item_Qty),
              //       docId,
              //       newMaxDoc,
              //       item.docNo,
              //       null
              //     );
              //   }
              // }

              // ส่งข้อมูลไปยัง API
              return Axios.post(
                `${process.env.REACT_APP_API_URL}/api/create-pk-list-d`,
                formDetailData,
                {
                  headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
                }
              );
            });

            // รอให้ Promise ทั้งหมดเสร็จสมบูรณ์
            await Promise.all(formDetailPromises);
          }

          await onRowSelected(formMasterData.doc_no);
          await getModelByNo();
          await handleChangeTabs("withdraw");

          setTimeout(() => {
            handleImportShow();
          }, 500);

          getAlert(response.data.status, response.data.message);
        } catch (error) {
          setIsLoading(false);
          getAlert("FAILED", error || error.message);
        }
      }

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleUpdate = async () => {
    try {
      setIsLoading(true);

      // ตรวจสอบว่า formDetailList มีค่าหรือมีความยาวเป็น 0
      if (!formDetailList || formDetailList.length === 0) {
        setIsLoading(false);
        getAlert("FAILED", "กรุณาเพิ่มอ้างอิงเอกสารสำหรับทำใบ Picking List");
        return; // หยุดการทำงานของฟังก์ชันหาก formDetailList ไม่มีค่า
      }

      // เฉพาะแก้ไขข้อมูลของสายส่ง
      if (selectedType === "DL") {
        if (formMasterList.pkCarId === null || formMasterList.pkCarId === "") {
          setIsLoading(false);
          getAlert("FAILED", "กรุณาเลือกรถส่งสินค้า");
          return;
        }
        if (
          (formMasterList.pkDriver1Id === null ||
            formMasterList.pkDriver1Id === "") &&
          (formMasterList.pkDriver2Id === null ||
            formMasterList.pkDriver2Id === "") &&
          (formMasterList.pkDriver3Id === null ||
            formMasterList.pkDriver3Id === "")
        ) {
          setIsLoading(false);
          getAlert("FAILED", "กรุณาเลือกคนขับรถอย่างน้อย 1 คน");
          return;
        }
      }

      // ข้อมูลหลักที่จะส่งไปยัง API
      const formMasterData = {
        comp_id: window.localStorage.getItem("company"),
        doc_no: formMasterList.docNo,
        doc_date: formatStringDateToDate(formMasterList.docDate),
        doc_status: formMasterList.docStatus,
        req_stc_status: formMasterList.reqStcStatus,
        delivery_line_id: formMasterList.deliveryLineId,
        pk_car_id: formMasterList.pkCarId,
        pk_car_no: formMasterList.pkCarNo,
        pk_round: parseCurrency(formMasterList.pkRound, 10),
        pk_driver_1_id: formMasterList.pkDriver1Id,
        pk_driver_2_id: formMasterList.pkDriver2Id,
        pk_driver_3_id: formMasterList.pkDriver3Id,
        created_date: formatThaiDateUiToDate(formMasterList.createdDate),
        created_by_name: formMasterList.createdByName,
        created_by_id: formMasterList.createdById,
        update_date: formatThaiDateUiToDate(formMasterList.updateDate),
        update_by_name: window.localStorage.getItem("name"),
        update_by_id: window.localStorage.getItem("emp_id"),
        cancel_date: formMasterList.cancelDate,
        cancel_by_name: formMasterList.cancelByName,
        cancel_by_id: formMasterList.cancelById,
        pk_doc_type: formMasterList.pkDocType,
      };

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/update-pk-list-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      // ตรวจสอบสถานะการตอบกลับ
      if (response.data.status === "OK") {
        // ลบข้อมูลเดิมก่อนจะเริ่มการบันทึกใหม่
        await deleteData("PKList_D", `WHERE Doc_ID = ${formMasterList.docId}`);

        const docId = parseCurrency(formMasterList.docId, 10);

        const detailPromises = formDetailList.map(async (item, index) => {
          const formDetailData = {
            doc_id: parseCurrency(docId, 10),
            dl_queue: index + 1,
            ar_id: item.arId,
            ar_code: item.arCode,
            ar_name: item.arName,
            so_id: item.soId,
          };

          return Axios.post(
            `${process.env.REACT_APP_API_URL}/api/create-pk-list-d`,
            formDetailData,
            {
              headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
            }
          );
        });

        await Promise.all(detailPromises);

        await onRowSelected(formMasterData.doc_no);
        await getModelByNo();

        setIsLoading(false);
        getAlert(response.data.status, response.data.message);
      }
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleCancel = async () => {
    try {
      setIsLoading(true);

      // ตรวจสอบข้อมูลที่จำเป็นก่อนเริ่มทำงาน
      if (!formMasterList.docNo || !formMasterList.docId) {
        setIsLoading(false);
        getAlert("FAILED", "Document number or Document ID is missing.");
        return;
      }

      // ข้อมูลหลักที่จะส่งไปยัง API
      const formMasterData = {
        doc_no: formMasterList.docNo,
        doc_status: parseCurrency("13", 10),
        cancel_date: formatThaiDateUiToDate(getCreateDateTime()),
        cancel_by_name: window.localStorage.getItem("name"),
        cancel_by_id: window.localStorage.getItem("emp_id"),
        comp_id: window.localStorage.getItem("company"),
      };

      // ส่งข้อมูลหลักไปยัง API สำหรับการยกเลิก
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/cancel-pk-list-h`,
        formMasterData,
        { headers: { key: process.env.REACT_APP_ANALYTICS_KEY } }
      );

      // ค้นหาใบเบิกสินค้าที่เกี่ยวข้องกับ Picking List
      const findWhDocById = await getDataWithComp(
        "WHDoc_H",
        `AND Ref_DocID = ${formMasterList.docId}`
      );

      if (findWhDocById && findWhDocById.length > 0) {
        // ถ้ามีใบเบิกที่เกี่ยวข้อง ให้จัดการการคืนของ
        if (formItemOnHandCaseTab && formItemOnHandCaseTab.length > 0) {
          for (const itemOnHandOnCar of formItemOnHandCaseTab) {
            // ตรวจสอบว่าจำนวน Onhand มากกว่า 0 หรือไม่ ถ้าเป็น 0 จะข้าม
            if (parseCurrency(itemOnHandOnCar.Item_Onhand) === 0) {
              continue; // ข้ามการทำงานสำหรับ item นี้
            }

            // #####################################
            // ย้ายออก (TO)
            // #####################################
            await manageWhItemData(
              itemOnHandOnCar.Item_Id,
              itemOnHandOnCar.Item_Code,
              itemOnHandOnCar.Item_Name,
              itemOnHandOnCar.WH_Id,
              "TO", // ประเภทการย้าย
              parseCurrency(itemOnHandOnCar.Item_Onhand),
              formMasterList.docId,
              maxDocNo,
              `ยกเลิก ${maxDocNo}`,
              null
            );

            // #####################################
            // ย้ายเข้า (TI)
            // #####################################
            await manageWhItemData(
              itemOnHandOnCar.Item_Id,
              itemOnHandOnCar.Item_Code,
              itemOnHandOnCar.Item_Name,
              findWhDocById[0].F_WH_Id,
              "TI", // ประเภทการย้ายเข้า
              parseCurrency(itemOnHandOnCar.Item_Onhand),
              formMasterList.docId,
              maxDocNo,
              `ยกเลิก ${maxDocNo}`,
              null
            );
          }
        }

        // #####################################
        // อัปเดตใบเบิกสินค้าที่เชื่อมโยงกับ Picking List โดยตั้งค่า ref_doc_id เป็น null
        // #####################################
        for (const whDocData of findWhDocById) {
          const formWhDocData = {
            wh_doc_no: whDocData.WHDoc_No,
            ref_doc_id: null,
          };

          await Axios.post(
            `${process.env.REACT_APP_API_URL}/api/update-ref-doc-by-no`,
            formWhDocData,
            {
              headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
            }
          );
        }
      }

      // รีเฟรชข้อมูลและแสดงข้อความตอบกลับจาก API
      callInitialize();
      setIsLoading(false);
      getAlert(response.data.status, response.data.message);
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleChangeMaster = async (e) => {
    const { name, value } = e.target;

    if (name === "pkCarId") {
      // เคลียค่าเดิม
      // setFormMasterList((prev) => ({
      //   ...prev,
      //   pkCarId: "",
      // }));

      // กรองหาข้อมูลที่ต้องการจาก carList
      const getCarNo = carList.find((car) => {
        const carId = selectedType === "SO" ? car.Car_id : car.DL_Car_id;

        // เปรียบเทียบ carId กับ value โดยแปลงเป็น String
        return carId.toString() === value.toString();
      });

      // ถ้าพบข้อมูลของรถ ให้ทำการเพิ่มค่าใน formMasterList.pkCarNo
      if (getCarNo) {
        setFormMasterList((prev) => ({
          ...prev,
          [name]: value,
          pkCarNo: getCarNo.Car_No, // ใช้ Car_No แทน DL_Car_No ถ้า DL_Car_No ไม่พบ
        }));

        // เรียกใช้ฟังชั่นดึงข้อมูลสินค้าคงเหลือ
        setSelectedWarehouseCode(getCarNo.Car_No);
        await onLoadOnHandCaseTab(getCarNo.Car_No);

        return;
      }
    }

    // เช็คคนขับที่ถูกเลือก
    const selectedDrivers = [
      formMasterList.pkDriver1Id,
      formMasterList.pkDriver2Id,
      formMasterList.pkDriver3Id,
    ];

    if (
      name === "pkDriver1Id" ||
      name === "pkDriver2Id" ||
      name === "pkDriver3Id"
    ) {
      // ตรวจสอบว่าคนขับที่เลือกซ้ำกับคนขับที่มีอยู่หรือไม่
      if (selectedDrivers.includes(value)) {
        getAlert("FAILED", "ไม่สามารถเลือกคนขับซ้ำกันได้");

        // เคลียร์ค่าของฟิลด์ที่เลือก
        setFormMasterList((prev) => ({
          ...prev,
          [name]: "",
        }));

        return;
      }
    }

    // อัปเดตค่าใน formMasterList ปกติสำหรับ field อื่น ๆ
    setFormMasterList((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangeDateMaster = (value, name) => {
    // ตรวจสอบว่า value เป็น moment object หรือไม่
    const newValue =
      value && value instanceof moment ? value.format("YYYY-MM-DD") : value;

    // อัปเดตค่าใน formMasterList
    setFormMasterList((prev) => ({
      ...prev,
      [name]: formatDateOnChange(newValue),
    }));
  };

  const handleChangeTabs = async (value) => {
    setActiveTab(value);
    if (value === "stockRemaining") {
      setItemList([]);
      await onLoadOnHandCaseTab(selectedWarehouseCode);
    }
    if (value === "withdraw") {
      await onLoadWithdrawCaseTab(formWdList);
    }
  };

  // SET SO
  const [showSoModal, setShowSoModal] = useState(false);
  const handleSoShow = () => setShowSoModal(true);
  const handleSoClose = () => setShowSoModal(false);
  const onRowSelectSo = async (soSelected) => {
    try {
      setSelectedType("SO");

      const soSelectedList = soSelected.map((item, index) => ({
        docId: null,
        dlQueue: index + 1,
        arId: item.AR_Id,
        arCode: item.AR_Code,
        arName: item.AR_Name,
        soId: item.Doc_ID,
        docNo: item.Doc_No,
      }));

      setFormDetailList(soSelectedList);
      handleSoClose();
    } catch (error) {
      getAlert("FAILED", error.message || error);
    }
  };
  const onConfirmSoSelection = async (soSelected) => {
    try {
      if (!soSelected[0]) {
        getAlert("FAILED", "ท่านยังไม่ได้เลือกใบขายสินค้า");
        return;
      }

      setFormDetailList([]);
      setCarList([]);
      setDriverList([]);

      onRowSelectSo(soSelected);

      // หารถส่งสินค้า && หาคนขับรถส่งสินค้า
      await fetchCarAndDriverList(``);

      handleSoClose();

      // แจ้งเตือนผู้ใช้ว่าการเลือกสำเร็จ
      getAlert("OK", "การเลือกใบขายสินค้าสำเร็จ");
    } catch (error) {
      getAlert("FAILED", error);
    }
  };

  // SET DL
  const onRowSelectDL = async (dlSelected) => {
    try {
      setIsLoading(true);

      // เก็บประเภทการดึงข้อมูลจาก DeliveryModal && รีเซ็ตค่า formDetailList
      setSelectedType("DL");
      setFormDetailList([]);

      // เก็บไอดีของสายส่งเอาไว้ใน State ด้วย เพื่อที่จะได้เอาไปบันทึก
      setDeliveryLineId(dlSelected.DL_Id);

      // หาสายส่ง
      const findLineList = await getData(
        "View_DL_Line",
        `DL_Id = ${dlSelected.DL_Id} ORDER BY DL_Queue ASC`
      );

      // ใช้ Array ชั่วคราวในการเก็บรายละเอียดฟอร์ม
      let updatedFormDetails = [];

      if (findLineList && findLineList.length > 0) {
        // เพิ่มรายละเอียดสายส่งลงใน updatedFormDetails
        const dlDetails = findLineList.map((dlLine) => ({
          docId: null,
          dlQueue: dlLine.DL_Queue,
          arId: dlLine.DL_AR_Id,
          arCode: dlLine.AR_Code,
          arName: dlLine.AR_Name,
          soId: null,
          docNo: null,
        }));

        // รวมข้อมูลลูกค้าเงินสดและรายละเอียดสายส่ง
        updatedFormDetails = updatedFormDetails.concat(dlDetails);

        // เพิ่มการแสดงสายส่ง
        setDlLineName(findLineList[0].DL_LineName);
      }

      // อัพเดต state ด้วยรายละเอียดที่รวมกัน
      setFormDetailList(updatedFormDetails);

      // หารถส่งสินค้า && หาคนขับรถส่งสินค้า
      await fetchCarAndDriverList(dlSelected.DL_Id);

      handleSoClose();

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.message || error);
    }
  };

  // เปิด Modal สำหรับดูรายละเอียดใบขาย
  const [showViewSoModal, setShowViewSoModal] = useState(false);
  const [selectedSoData, setSelectedSoData] = useState(null);
  const handleViewSoClose = () => {
    setShowViewSoModal(false);
    setSelectedSoData(null);

    // ลบ class 'modal-open' จาก body
    document.body.classList.remove("modal-open");

    // ลบ element ที่อาจถูกซ้อน เช่น backdrop ของ Modal
    const backdrops = document.getElementsByClassName("modal-backdrop");
    while (backdrops.length > 0) {
      backdrops[0].parentNode.removeChild(backdrops[0]);
    }
  };
  const handleViewSo = (soData) => {
    setSelectedSoData(soData);
    setShowViewSoModal(true);
  };

  // SET AR
  const [showArModal, setShowArModal] = useState(false);
  const handleArShow = () => setShowArModal(true);
  const handleArClose = () => setShowArModal(false);
  const onRowSelectAr = (arSelected) => {
    try {
      // สร้างรายการใหม่ที่จะเพิ่มเข้าไปใน formMasterList
      const newRow = {
        docId: null,
        dlQueue: parseCurrency(formDetailList.length) + 1,
        arId: arSelected.AR_Id,
        arCode: arSelected.AR_Code,
        arName: arSelected.AR_Name,
        soId: null,
        docNo: null,
      };

      setFormDetailList((prevState) => {
        if (prevState.length === 0) {
          // ถ้า formMasterList ว่างเปล่า, ให้สร้างรายการใหม่
          return [newRow];
        }

        // ตรวจสอบว่ามีข้อมูลเดียวกันในรายการแล้วหรือไม่
        const isAlreadyPresent = prevState.some(
          (item) => item.arId === arSelected.AR_Id
        );

        // ถ้ามีข้อมูลอยู่แล้ว แจ้งเตือน + คืนค่าเดิม
        if (isAlreadyPresent) {
          getAlert("FAILED", "ไม่สามารถเพิ่มลูกค้าซ้ำกันได้");
          return prevState;
        }

        // เพิ่มรายการใหม่ถ้ายังไม่มี
        return [...prevState, newRow];
      });

      handleArClose(); // ปิด modal หลังจากเลือก
    } catch (error) {
      getAlert("FAILED", error.message || error);
    }
  };

  // SET IMPORT
  const [showImportModal, setShowImportModal] = useState(false);
  const handleImportShow = () => setShowImportModal(true);
  const handleImportClose = () => setShowImportModal(false);
  const onConfirmImportSelection = async (importSelected) => {
    try {
      if (!importSelected[0]) {
        getAlert("FAILED", "ท่านยังไม่ได้เลือกใบเบิกเพื่อเตรียมของเข้ารถ");
        return;
      }

      const updatedFormWdList = [...formWdList];
      importSelected.forEach((importData) => {
        const existingIndex = updatedFormWdList.findIndex(
          (existingData) => existingData.WHDoc_No === importData.WHDoc_No
        );

        if (existingIndex !== -1) {
          updatedFormWdList[existingIndex] = importData;
        } else {
          updatedFormWdList.push(importData);
        }
      });

      // เก็บค่าที่เลือกไว้ใน selectedImports
      setSelectedImports(importSelected);

      await handleImportClose();

      setFormWdList(updatedFormWdList);
      await onLoadWithdrawCaseTab(importSelected);
      await onRowSelected(formMasterList.docNo);
      await getModelByNo();
      // getAlert("OK", "เตรียมของเข้ารถสำเร็จ");
    } catch (error) {
      getAlert("FAILED", "เกิดข้อผิดพลาดในการเลือกนำเข้าสำเร็จ");
    }
  };
  const handleConfirmImport = async () => {
    try {
      // ทำการ SET OnLoad ตอนเข้าครั้งแรก
      setOnLoadConfirm(true);

      // ทำการตัด Stock จากรายการนำเข้า
      if (formWdList && formWdList.length > 0) {
        for (const formWd of formWdList) {
          let formMasterData = {
            wh_doc_no: formWd.WHDoc_No,
            ref_doc_id: formMasterList.docId,
            comp_id: localStorage.getItem("company"),
          };
          const response = await Axios.post(
            `${process.env.REACT_APP_API_URL}/api/update-ref-doc-by-no`,
            formMasterData,
            {
              headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
            }
          );

          // ตรวจสอบสถานะการตอบกลับ
          if (response.data.status === "OK") {
            try {
              let detailList = await getData(
                "WHDoc_D",
                `WHDoc_Id = ${parseCurrency(formWd.WHDoc_Id)} ORDER BY Line ASC`
              );

              if (detailList && detailList.length > 0) {
                for (const detail of detailList) {
                  let findWarehouse = await getDataWithComp(
                    "WHDoc_H",
                    `AND WHDoc_Id = ${parseCurrency(detail.WHDoc_Id)}`
                  );

                  // ย้ายออก
                  await manageWhItemData(
                    detail.Item_Id, // Item ไอดีของสิ่งนั้นๆ
                    detail.Item_Code, // Item โค้ดของสิ่งนั้นๆ
                    detail.Item_Name, // ชื่อ Item นั้นๆ
                    findWarehouse[0].F_WH_Id, // WarehouseID ของไอเทม
                    "TO", // ประเภท เช่น IN/OUT/AI/AO/TI/TO
                    parseCurrency(detail.Item_Qty), // ค่าจำนวนที่กรอกจากหน้าจอ
                    formMasterList.docId, // ไอดีเอกสาร
                    maxDocNo, // เลขเอกสาร
                    formWd.WHDoc_No, // เลขเอกสารอ้างอิง
                    formWd.WHDoc_Remark // หมายเหตุ
                  );

                  // ย้ายเข้า
                  await manageWhItemData(
                    detail.Item_Id, // Item ไอดีของสิ่งนั้นๆ
                    detail.Item_Code, // Item โค้ดของสิ่งนั้นๆ
                    detail.Item_Name, // ชื่อ Item นั้นๆ
                    findWarehouse[0].T_WH_Id, // WarehouseID ของไอเทม
                    "TI", // ประเภท เช่น IN/OUT/AI/AO/TI/TO
                    parseCurrency(detail.Item_Qty), // ค่าจำนวนที่กรอกจากหน้าจอ
                    formMasterList.docId, // ไอดีเอกสาร
                    maxDocNo, // เลขเอกสาร
                    formWd.WHDoc_No, // เลขเอกสารอ้างอิง
                    formWd.WHDoc_Remark // หมายเหตุ
                  );
                }
              }
            } catch (error) {
              getAlert("FAILED", error || error.message);
            }
          }
        }
        await handleRemoveFormWd();
        setOnLoadConfirm(false);
        getAlert(
          "OK",
          "ยืนยันรายการนำเข้าสินค้าทั้งหมด " +
          formItemWithdrawCaseTab.length +
          " รายการสำเร็จ"
        );
      }
    } catch (error) {
      setOnLoadConfirm(false);
      getAlert("FAILED", error || error.message);
    }
  };

  const handleRemoveFormWd = () => {
    setFormWdList([]);
    setFormItemWithdrawCaseTab([]);
    setSelectedImports([]);
    // getAlert("OK", "ยกเลิกรายการนำเข้าสินค้าสำเร็จ");
  };

  const fetchCarAndDriverList = async (dlId) => {
    let findCarList;

    if (dlId) {
      // ถ้า dlId มีค่า
      findCarList = await getDataWithComp("View_DL_Car", `AND DL_Id = ${dlId}`);
    } else {
      // ถ้า dlId ไม่มีค่า
      findCarList = await getDataWithComp("Tb_Set_Car", `AND Car_Status = 'Y'`);
    }

    if (findCarList && findCarList.length > 0) {
      setCarList(findCarList);
    } else {
      setCarList([]); // เผื่อกรณีไม่มีข้อมูล
    }

    // หาคนขับรถส่งสินค้า
    const findDriverList = await getDataWithComp(
      "Tb_Set_Employee",
      `AND Emp_Status = 'Y' AND Emp_Position IN (7,8,9)`
    );
    if (findDriverList && findDriverList.length > 0) {
      setDriverList(findDriverList);
    } else {
      setDriverList([]); // เผื่อกรณีไม่มีข้อมูล
    }
  };

  // แสดงรายละเอียดการส่งสินค้า (แค่แสดงเฉยๆ ไม่ได้ Map Field ข้อมูลไปบันทึก)
  const handleDisplayItem = async (data) => {
    try {
      // อัปเดต Active Tab
      setActiveTab("deliveryDetails");

      // เคลียร์ค่าก่อนโหลดข้อมูลใหม่
      setSoListData([]);
      setItemList([]);
      setFormItemOnHandCaseTab([]);

      // ค้นหาใบขาย (SO)
      const findSoList = await getData(
        "API_0701_SO_H",
        `AR_ID = ${data.arId} AND Doc_Is_PickingList = ${data.docId}`
      );

      if (findSoList && findSoList.length > 0) {
        const soDataWithDetails = await Promise.all(
          findSoList.map(async (so) => {
            const soDetails = await getData(
              "API_0702_SO_D",
              `Doc_ID = ${so.Doc_ID}`
            );
            return {
              ...so,
              details: soDetails || [], // เพิ่ม `details` สำหรับแต่ละใบขาย
            };
          })
        );

        setSoListData(soDataWithDetails);
      } else {
        setSoListData([]);
      }
    } catch (error) {
      getAlert("FAILED", error.message || error);
    }
  };

  // ลบข้อมูลรายชื่อลูกค้า
  const handleRemove = (index, event) => {
    try {
      // ไม่ให้มันไปเข้าฟังชั่น handleDisplayItem
      event.stopPropagation();

      // ตรวจสอบว่ามีข้อมูลมากกว่า 1 รายการ
      if (formDetailList.length > 1) {
        // อัปเดต formMasterList โดยการกรองออกแถวที่ต้องการลบ
        setFormDetailList((prevState) => {
          // กรองรายการที่ไม่ใช่รายการที่ต้องการลบ
          const updatedList = prevState.filter((_, i) => i !== index);
          return updatedList;
        });
      } else {
        // แจ้งเตือนถ้ามีรายการเหลือเพียง 1 รายการ
        getAlert(
          "FAILED",
          "ไม่สามารถลบข้อมูลลูกค้าได้ เนื่องจากการสร้างใบ Picking List ต้องมีข้อมูลลูกค้าอย่างน้อย 1 คน"
        );
      }
    } catch (error) {
      getAlert("FAILED", error);
    }
  };

  // const handleDragStart = (e, index) => {
  //   e.dataTransfer.setData("dragItemIndex", index);
  // };

  // const handleDrop = (e, dropIndex) => {
  //   const dragIndex = e.dataTransfer.getData("dragItemIndex");
  //   if (dragIndex === dropIndex) return;

  //   const updatedItems = [...formDetailList];
  //   const [draggedItem] = updatedItems.splice(dragIndex, 1);
  //   updatedItems.splice(dropIndex, 0, draggedItem);

  //   setFormDetailList(updatedItems);
  // };

  // const handleDragOver = (e) => {
  //   e.preventDefault();
  // };

  const handleMoveUp = (index) => {
    if (index === 0) return;
    const updatedItems = [...formDetailList];
    const temp = updatedItems[index];
    updatedItems[index] = updatedItems[index - 1];
    updatedItems[index - 1] = temp;
    setFormDetailList(updatedItems);
  };

  const handleMoveDown = (index) => {
    if (index === formDetailList.length - 1) return;
    const updatedItems = [...formDetailList];
    const temp = updatedItems[index];
    updatedItems[index] = updatedItems[index + 1];
    updatedItems[index + 1] = temp;
    setFormDetailList(updatedItems);
  };

  // Service ตรวจสอบเกี่ยวกับคลัง Vansale
  const [isVansaleCloseForWarehouse, setIsVansaleCloseForWarehouse] = useState(false);
  const hideVansaleCloseForWarehouse = async () => {
    setIsVansaleCloseForWarehouse(false);
    await onRowSelected(formMasterList.docNo);
    await getModelByNo();
  };

  // Service ตรวจสอบเกี่ยวกับเงิน Vansale
  const [isVansaleCloseForAccount, setIsVansaleCloseForAccount] = useState(false);
  const hideVansaleCloseForAccount = async () => {
    setIsVansaleCloseForAccount(false);
    await onRowSelected(formMasterList.docNo);
    await getModelByNo();
  };

  // ฟังก์ชันกรองข้อมูลตามชื่อ
  const filteredList = formDetailList.filter((data) =>
    data.arName.toLowerCase().includes(searchCustomer.toLowerCase())
  );

  return (
    <>
      <Breadcrumbs
        page={maxDocNo}
        isShowStatus={mode === "U"}
        statusName={statusName}
        statusColour={statusColour}
        otherStatusName={reqStcStatusName}
        otherStatusColour={reqStcStatusColour}
        docStatusForClosePK={formMasterList.docStatus}
        items={[
          { name: "ขายสินค้า", url: "/sellproducts" },
          { name: name, url: "/picking-list" },
          {
            name: mode === "U" ? "เรียกดู " + name : "สร้าง " + name,
            url: "#",
          },
        ]}
        onHandleClick={() => getReport("pklist", formMasterList.docNo)}
        onHandleCloseForWarehouse={() => setIsVansaleCloseForWarehouse(true)}
        onHandleCloseForAccount={() => setIsVansaleCloseForAccount(true)}
        onHandleInvoice1={async () => {
          setIsLoading(true);
          await ExportVansaleSalesReport(formMasterList.docId, maxDocNo);
          setIsLoading(false);
        }}

      />
      <CloseVansaleForWarehouseModal
        isVansaleCloseForWarehouse={isVansaleCloseForWarehouse}
        hideVansaleCloseForWarehouse={hideVansaleCloseForWarehouse}
        pkId={formMasterList.docId}
      />
      <CloseVansaleForAccountModal
        isVansaleCloseForAccount={isVansaleCloseForAccount}
        hideVansaleCloseForAccount={hideVansaleCloseForAccount}
        pkId={formMasterList.docId}
      />

      {/* Loading Spinner */}
      {isLoading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 d-flex justify-content-center align-items-center"
          style={{ zIndex: 9999 }}
        >
          <div className="spinner-border text-light" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}

      <div className="hidden-scrollbar" style={{ maxHeight: "auto", overflowY: "auto" }}>
        <div className="row mt-1">
          <div className="col-3 text-left">
            <div className="d-flex align-items-center">
              <label>วันที่เอกสาร</label>
              <Datetime
                className="input-spacing-input-date"
                name="docDate"
                value={formMasterList.docDate || new Date()}
                onChange={(date) => handleChangeDateMaster(date, "docDate")}
                dateFormat="DD-MM-YYYY"
                timeFormat={false}
                inputProps={{ readOnly: true, disabled: mode === "U" }}
              />
            </div>
          </div>
          <div className="col-4 text-left">
            <div className="d-flex align-items-center">
              <label>
                รถส่งสินค้า <span style={{ color: "red" }}>*</span>
              </label>
              <select
                name="pkCarId"
                value={formMasterList?.pkCarId || ""}
                onChange={(e) => handleChangeMaster(e)}
                className="form-select form-control input-spacing"
                disabled={selectedType === "" || mode === "U"}
              >
                <option value="">กรุณาเลือกรถส่งสินค้า</option>
                {carList
                  .filter((car) => car.Car_No && car.Car_Name)
                  .map((car, index) => {
                    // คำนวณค่า value ที่จะใช้
                    const carId =
                      selectedType === "SO" ? car.Car_id : car.DL_Car_id;
                    return (
                      <option key={index + 1} value={carId}>
                        {car.Car_No} ({car.Car_Name})
                      </option>
                    );
                  })}
              </select>
            </div>
          </div>
          <div className="col-2" />
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>วันที่สร้างเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="createdDate"
                value={formMasterList.createdDate}
                onChange={(e) => handleChangeMaster(e)}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3">
            <div className="d-flex align-items-center">
              <label>อ้างอิงเอกสาร</label>
              <div className="input-group">
                <input
                  type="text"
                  value={`สายส่ง : ${dlLineName}`}
                  className="form-control input-spacing"
                  disabled={true}
                />
                <button
                  className="btn btn-outline-secondary"
                  onClick={handleSoShow}
                  disabled={mode === "U"}
                >
                  <i className="fas fa-search"></i>
                </button>
              </div>
            </div>
            <DeliveryModal
              showSoModal={showSoModal}
              handleSoClose={handleSoClose}
              soDataList={soDataList}
              dlLineList={dlLineList}
              onConfirmSoSelection={onConfirmSoSelection}
              onRowSelectDL={onRowSelectDL}
            />
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label>
                คนขับรถส่งสินค้าที่ 1 <span style={{ color: "red" }}>*</span>
              </label>
              <select
                name="pkDriver1Id"
                value={formMasterList.pkDriver1Id}
                onChange={(e) => handleChangeMaster(e)}
                className="form-select form-control input-spacing"
                disabled={selectedType === "" || formMasterList.docStatus !== 1}
              >
                <option value="">กรุณาเลือกคนขับรถส่งสินค้าที่ 1</option>
                {driverList.map((driver) => (
                  <option key={driver.Emp_Id} value={driver.Emp_Id}>
                    {driver.Emp_Name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-2" />
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>ผู้สร้างเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="createdByName"
                value={formMasterList.createdByName || ""}
                onChange={(e) => handleChangeMaster(e)}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3">
            <div className="d-flex align-items-center">
              <label>รอบ</label>
              <select
                name="pkRound"
                value={formMasterList.pkRound || ""}
                onChange={(e) => handleChangeMaster(e)}
                disabled={mode === "U"}
                className="form-select form-control input-spacing"
              >
                <option value="1">เช้า</option>
                <option value="2">เย็น</option>
                <option value="3">ค่ำ</option>
              </select>
            </div>
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label>คนขับรถส่งสินค้าที่ 2</label>
              <select
                name="pkDriver2Id"
                value={formMasterList.pkDriver2Id}
                onChange={(e) => handleChangeMaster(e)}
                className="form-select form-control input-spacing"
                disabled={selectedType === "" || formMasterList.docStatus !== 1}
              >
                <option value="">กรุณาเลือกคนขับรถส่งสินค้าที่ 2</option>
                {driverList.map((driver) => (
                  <option key={driver.Emp_Id} value={driver.Emp_Id}>
                    {driver.Emp_Name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-2" />
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>วันที่แก้ไขล่าสุด</label>
              <input
                // type="date"
                type="text"
                className="form-control input-spacing"
                name="updateDate"
                value={formMasterList.updateDate || ""}
                onChange={(e) => handleChangeMaster(e)}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3">
            {/* <div className="d-flex align-items-center">
            <label>ประเภทเอกสาร</label>
            <select
              className="form-select form-control input-spacing"
              name="docType"
              value={formMasterList.docType}
              onChange={handleChangeMaster}
              disabled={formMasterList.docStatus !== 1}
            >
              {tbDocType.map((docType) => (
                <option key={docType.DocType_Id} value={docType.DocType_Id}>
                  {docType.DocType_Name}
                </option>
              ))}
            </select>
          </div> */}
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label>คนขับรถส่งสินค้าที่ 3</label>
              <select
                name="pkDriver3Id"
                value={formMasterList.pkDriver3Id}
                onChange={(e) => handleChangeMaster(e)}
                className="form-select form-control input-spacing"
                disabled={selectedType === "" || formMasterList.docStatus !== 1}
              >
                <option value="">กรุณาเลือกคนขับรถส่งสินค้าที่ 3</option>
                {driverList.map((driver) => (
                  <option key={driver.Emp_Id} value={driver.Emp_Id}>
                    {driver.Emp_Name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-2" />
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>ผู้แก้ไขเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="updateByName"
                value={formMasterList.updateByName || ""}
                onChange={(e) => handleChangeMaster(e)}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3">
            {/* <div className="d-flex align-items-center">
            <label>วัตถุประสงค์</label>
            <select
              name="docFor"
              value={formMasterList.docFor}
              onChange={handleChangeMaster}
              className="form-select form-control input-spacing"
              disabled={formMasterList.docStatus !== 1}>
              <option value="1">ซื้อมาเพื่อใช้</option>
              <option value="2">ซื้อมาเพื่อขาย</option>
            </select>
          </div> */}
          </div>
          <div className="col-4">
            {/* <div className="d-flex align-items-center">
            <label>เลขที่ภาษี</label>
            <input
              type="text"
              className="form-control input-spacing"
              value={formMasterList.arTaxNo || ''}
              disabled={true} />
          </div> */}
          </div>
          <div className="col-2" />
          <div className="col-3 text-right">
            {/* <div className="d-flex align-items-center">
            <label>วันที่อนุมัติ</label>
            <input
              type="text"
              className="form-control input-spacing"
              name="approvedDate"
              value={formMasterList.approvedDate || ''}
              onChange={handleChangeMaster}
              disabled={true} />
          </div> */}
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3">
            {/* <div className="d-flex align-items-center">
            <label>Due Date</label>
            <Datetime
              className="input-spacing-input-date"
              name="docDueDate"
              value={formMasterList.docDueDate || null}
              onChange={(date) => handleChangeDateMaster(date, 'docDueDate')}
              dateFormat="DD-MM-YYYY"
              timeFormat={false}
              inputProps={{ readOnly: true, disabled: formMasterList.docStatus === 1 ? false : true }}
            />
          </div> */}
          </div>
          <div className="col-6" />
          <div className="col-3 text-right">
            {/* <div className="d-flex align-items-center">
            <label>ผู้อนุมัติเอกสาร</label>
            <input
              type="text"
              className="form-control input-spacing"
              name="approvedByName"
              value={formMasterList.approvedByName || ''}
              onChange={handleChangeMaster}
              disabled={true} />
          </div> */}
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3">
            {/* <div className="d-flex align-items-center">
            <label>วิธีจัดส่ง</label>
            <select
              name="transportType"
              value={formMasterList.transportType}
              onChange={handleChangeMaster}
              className="form-select form-control input-spacing"
              disabled={formMasterList.docStatus !== 1}
            >
              {tbTransType.map((transType) => (
                <option key={transType.Trans_TypeID} value={transType.Trans_TypeID}>
                  {transType.Trans_TypeName}
                </option>
              ))}
            </select>
          </div> */}
          </div>
          <div className="col-6" />
          <div className="col-3 text-right">
            {/* <div className="d-flex align-items-center">
            <label>หมายเหตุอนุมัติ</label>
            <input
              type="text"
              className="form-control input-spacing"
              name="approvedMemo"
              value={formMasterList.approvedMemo || ''}
              onChange={handleChangeMaster}
              disabled={true} />
          </div> */}
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-4" style={{ borderRight: "2px solid #c7c8c9" }}>
            <div className="col-12">
              <div className="card">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <h4 className="card-title">
                    รายชื่อลูกค้า ({filteredList.length || 0})
                  </h4>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="ค้นหาชื่อลูกค้า"
                    value={searchCustomer}
                    onChange={(e) => setSearchCustomer(e.target.value)}
                    style={{ width: '200px' }}
                  />
                  <button
                    className="btn btn-outline-secondary"
                    onClick={handleArShow}
                    disabled={mode === "U" || selectedType === ""}
                  >
                    <i className="fas fa-search" />
                  </button>
                  <ArModal
                    showArModal={showArModal}
                    handleArClose={handleArClose}
                    arDataList={arDataList}
                    onRowSelectAr={onRowSelectAr}
                  />
                </div>
                <div className="card-body">
                  <div className="table-responsive" style={{ maxHeight: "500px", overflowY: "auto" }}>
                    <table id="basic-datatables" className="table table-striped table-hover">
                      <thead className="thead-dark">
                        <tr>
                          <th className="text-center" style={{ width: "5%" }}>ลำดับ</th>
                          <th className="text-center" style={{ width: "60%" }}>ชื่อลูกค้า</th>
                          <th className="text-center" style={{ width: "30%" }}>สถานะ</th>
                          <th className="text-center" style={{ width: "5%" }}>ลบ</th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedType !== "" && filteredList.length > 0 ? (
                          filteredList.map((data, index) => (
                            <tr
                              key={data.docId || index + 1}
                              style={{
                                cursor: 'pointer',
                                transition: 'background-color 0.3s ease',
                              }}
                              onClick={() => handleDisplayItem(data)}
                            >
                              <td className="text-center">
                                <button
                                  type="button"
                                  className="btn btn-link"
                                  onClick={() => handleMoveUp(index)}
                                  disabled={index === 0}
                                >
                                  <i
                                    className="fas fa-arrow-up"
                                    style={{
                                      color: index === 0 ? "#c0c0c0" : "#EF6C00",
                                    }}
                                  />
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-link"
                                  onClick={() => handleMoveDown(index)}
                                  disabled={index === filteredList.length - 1}
                                >
                                  <i
                                    className="fas fa-arrow-down"
                                    style={{
                                      color: index === filteredList.length - 1 ? "#c0c0c0" : "#EF6C00",
                                    }}
                                  />
                                </button>
                              </td>
                              <td className="text-left">{data.dlQueue}. {data.arName}</td>
                              <td className="text-center">
                                <button
                                  type="button"
                                  className="btn"
                                  style={{
                                    backgroundColor: data.soId ? "green" : "red",
                                    color: "white",
                                  }}
                                >
                                  {data.soId ? "จัดส่ง" : "ไม่จัดส่ง"}
                                </button>
                              </td>
                              <td className="text-center">
                                <button
                                  type="button"
                                  className="btn btn-danger"
                                  onClick={(event) => handleRemove(index, event)}
                                  disabled={formMasterList.docStatus !== 1}
                                >
                                  ลบ
                                </button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="5">
                              <center>
                                <h5>ไม่พบข้อมูล</h5>
                              </center>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-8">
            <div className="card">
              <div className="card-header">
                <ul className="nav nav-tabs">
                  <li className="nav-item">
                    <button
                      style={{ cursor: "pointer", color: "#EF6C00" }}
                      className={`nav-link ${activeTab === "deliveryDetails" ? "active" : ""
                        }`}
                      onClick={() => handleChangeTabs("deliveryDetails")}
                    >
                      รายละเอียดการส่งสินค้า
                    </button>
                  </li>
                  <li className="nav-item">
                    <button
                      style={{ cursor: "pointer", color: "#EF6C00" }}
                      className={`nav-link ${activeTab === "stockRemaining" ? "active" : ""
                        }`}
                      onClick={() => handleChangeTabs("stockRemaining")}
                    >
                      สินค้าคงเหลือ
                    </button>
                  </li>
                  <li className="nav-item">
                    <button
                      style={{ cursor: "pointer", color: "#EF6C00" }}
                      className={`nav-link ${activeTab === "withdraw" ? "active" : ""
                        }`}
                      onClick={() => handleChangeTabs("withdraw")}
                    >
                      รายการนำเข้า
                    </button>
                  </li>
                </ul>
              </div>
              <div className="card-body">
                {activeTab === "deliveryDetails" && (
                  <>
                    {Array.isArray(soListData) && soListData.length > 0 ? (
                      soListData.map((soData, index) => {
                        // คำนวณยอดรวมของใบขายปัจจุบัน
                        const totals = soData.details
                          ? soData.details
                            .filter((detail) => detail.Item_Qty > 0)
                            .reduce(
                              (acc, detail) => {
                                const discountValue =
                                  detail.Item_DisType === "2"
                                    ? (detail.Item_Total / 100) * detail.Item_Discount
                                    : detail.Item_Discount;
                                const priceAfterDiscount = detail.Item_Total - discountValue;
                                const vat = detail.IsVat === 1 ? priceAfterDiscount * 0.07 : 0;
                                const totalPrice = priceAfterDiscount + vat;

                                return {
                                  totalItemPrice: acc.totalItemPrice + detail.Item_Total,
                                  totalDiscount: acc.totalDiscount + discountValue,
                                  totalPriceAfterDiscount:
                                    acc.totalPriceAfterDiscount + priceAfterDiscount,
                                  totalVat: acc.totalVat + vat,
                                  grandTotal: acc.grandTotal + totalPrice,
                                };
                              },
                              {
                                totalItemPrice: 0,
                                totalDiscount: 0,
                                totalPriceAfterDiscount: 0,
                                totalVat: 0,
                                grandTotal: 0,
                              }
                            )
                          : {
                            totalItemPrice: 0,
                            totalDiscount: 0,
                            totalPriceAfterDiscount: 0,
                            totalVat: 0,
                            grandTotal: 0,
                          };

                        return (
                          <div className="card shadow-sm mb-4" key={index}>
                            <div
                              className="card-header text-white d-flex justify-content-between align-items-center"
                              style={{ backgroundColor: "#EF6C00" }}
                            >
                              <h5 className="mb-0 d-flex align-items-center justify-content-between">
                                <span style={{ marginRight: "20px" }}>
                                  ใบขาย: <span className="fw-bold">{soData.Doc_No}</span>
                                </span>
                                <span
                                  className="badge bg-primary text-white"
                                  style={{
                                    fontSize: "1.2rem",
                                    padding: "0.5rem 1rem",
                                    borderRadius: "0.5rem",
                                    borderColor: "#EF6C00",
                                  }}
                                >
                                  รวมทั้งสิ้น: {formatCurrency(totals.grandTotal)} ฿
                                </span>
                              </h5>
                              <div>
                                {/* ปุ่มดูหลักฐานเงินโอน */}
                                {soData.DocStatusPaid_Type_Name === "เงินโอน" && (
                                  <button
                                    className="btn btn-light btn-md me-2"
                                    onClick={() => {
                                      setShowSlipModal(true);
                                    }}
                                  >
                                    <i className="fa fa-eye"></i> ดูหลักฐานเงินโอน
                                  </button>
                                )}
                                <button
                                  className="btn btn-light btn-md me-2"
                                  onClick={() => handleViewSo(soData)}
                                >
                                  <i className="fa fa-eye"></i> ดูใบขาย
                                </button>
                                <button
                                  className="btn btn-light btn-md"
                                  onClick={() => getReport("rc", soData.Doc_No)}
                                >
                                  <i className="fa fa-print"></i> พิมพ์บิล
                                </button>
                              </div>
                            </div>
                            <div className="card-body">
                              <div className="d-flex flex-wrap justify-content-between align-items-center text-center gap-3">
                                <div className="flex-grow-1">
                                  <strong>วันที่:</strong>{" "}
                                  {formatDate(soData.Doc_Date)}
                                </div>
                                <div className="flex-grow-1">
                                  <strong>สถานะเอกสาร:</strong>{" "}
                                  <span
                                    className="badge text-white"
                                    style={{
                                      backgroundColor: soData.DocStatus_Colour,
                                      fontSize: "1.1rem",
                                      padding: "0.5rem 1rem",
                                      borderRadius: "0.5rem",
                                    }}
                                  >
                                    {soData.DocStatus_Name}
                                  </span>
                                </div>
                                <div className="flex-grow-1">
                                  <strong>สถานะจ่าย:</strong>{" "}
                                  <span
                                    className="badge text-white"
                                    style={{
                                      backgroundColor:
                                        soData.DocStatusPaid_Colour,
                                      fontSize: "1.1rem",
                                      padding: "0.5rem 1rem",
                                      borderRadius: "0.5rem",
                                    }}
                                  >
                                    {soData.DocStatusPaid_Name}
                                  </span>
                                </div>
                                <div className="flex-grow-1">
                                  <strong>ประเภทจ่าย:</strong>{" "}
                                  <span
                                    className="badge text-white"
                                    style={{
                                      backgroundColor:
                                        soData.DocStatusPaidType_Colour,
                                      fontSize: "1.1rem",
                                      padding: "0.5rem 1rem",
                                      borderRadius: "0.5rem",
                                    }}
                                  >
                                    {soData.DocStatusPaid_Type_Name}
                                  </span>
                                  {/* Modal สำหรับแสดงสลิปเงินโอน */}
                                  {showSlipModal && (
                                    <div
                                      className="modal"
                                      style={{
                                        display: "block",
                                        backgroundColor: "rgba(0, 0, 0, 0.1)",
                                        zIndex: 1050,
                                      }}
                                    >
                                      <div
                                        className="modal-dialog modal-md"
                                        role="document"
                                      >
                                        <div
                                          className="modal-content shadow-lg"
                                          style={{
                                            borderRadius: "15px",
                                            overflow: "hidden",
                                            maxHeight: "auto",
                                          }}
                                        >
                                          <div
                                            className="modal-header"
                                            style={{
                                              backgroundColor: "#EF6C00",
                                              borderBottom: "none",
                                              padding: "15px",
                                            }}
                                          >
                                            <h5 className="modal-title fw-bold text-white">
                                              ชำระเงิน
                                            </h5>
                                            <button
                                              type="button"
                                              className="btn-close btn-close-white"
                                              onClick={() =>
                                                setShowSlipModal(false)
                                              }
                                              aria-label="Close"
                                            ></button>
                                          </div>
                                          <div
                                            className="modal-body"
                                            style={{
                                              padding: "20px",
                                              display: "flex",
                                              flexDirection: "column",
                                              justifyContent: "center",
                                              alignItems: "center",
                                              height: "100%",
                                            }}
                                          >
                                            {soData.Doc_Paid_Pic === null ? (
                                              <h4 style={{ textAlign: "center" }}>
                                                ไม่พบรูปภาพ
                                              </h4>
                                            ) : (
                                              <img
                                                src={soData.Doc_Paid_Pic}
                                                alt="ชำระเงิน"
                                                style={{
                                                  width: "100%",
                                                  height: "auto",
                                                  borderRadius: "10px",
                                                  display: "block",
                                                  margin: "0 auto",
                                                }}
                                              />
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                                <div className="flex-grow-1">
                                  <strong>สถานะ VAT:</strong>{" "}
                                  <span
                                    className="badge text-white"
                                    style={{
                                      backgroundColor:
                                        soData.IsVat === 1 ? "green" : "red",
                                      fontSize: "1.1rem",
                                      padding: "0.5rem 1rem",
                                      borderRadius: "0.5rem",
                                    }}
                                  >
                                    {soData.IsVat === 1 ? "VAT" : "NO VAT"}
                                  </span>
                                </div>
                              </div>

                              {/* รายการสินค้า */}
                              <div className="mt-4">
                                <details className="mt-3">
                                  <summary
                                    className="fw-bold mb-3"
                                    style={{
                                      cursor: "pointer",
                                      color: "#EF6C00",
                                      fontSize: "1.2rem",
                                      borderBottom: "1px solid #ddd",
                                      paddingBottom: "0.3rem",
                                      marginLeft: "25px",
                                    }}
                                  >
                                    ดูรายการสินค้า
                                  </summary>
                                  {soData.details && soData.details.length > 0 ? (
                                    <>
                                      {/* แสดงรายการสินค้า */}
                                      {soData.details
                                        .filter((detail) => detail.Item_Qty > 0)
                                        .map((detail, idx) => (
                                          <div
                                            key={idx}
                                            className="card mb-3 p-3"
                                            style={{
                                              border: "1px solid #ddd",
                                              borderRadius: "10px",
                                              backgroundColor: "#fff",
                                              marginLeft: "25px",
                                              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                            }}
                                          >
                                            <div className="d-flex justify-content-between">
                                              <h5 className="mb-1">
                                                <strong>สินค้า: {detail.Item_Name}</strong>
                                              </h5>
                                              <span className="text-muted">(รหัส: {detail.Item_Code})</span>
                                            </div>
                                            <div className="mt-2">
                                              <p className="mb-1">
                                                <strong>จำนวน:</strong> {detail.Item_Qty} {detail.Item_Unit}
                                              </p>
                                              <p className="mb-1">
                                                <strong>ราคาต่อหน่วย:</strong> {formatCurrency(detail.Item_Price_Unit)} ฿
                                              </p>
                                              <p className="mb-1">
                                                <strong>ราคารวมต่อไอเทม:</strong> {formatCurrency(detail.Item_Total)} ฿
                                              </p>
                                            </div>
                                          </div>
                                        ))}

                                      {/* คำนวณผลรวม */}
                                      {(() => {
                                        const totals = soData.details
                                          .filter((detail) => detail.Item_Qty > 0)
                                          .reduce(
                                            (acc, detail) => {
                                              const discountValue =
                                                detail.Item_DisType === "2"
                                                  ? (detail.Item_Total / 100) * detail.Item_Discount
                                                  : detail.Item_Discount;
                                              const priceAfterDiscount = detail.Item_Total - discountValue;
                                              const vat = detail.IsVat === 1 ? priceAfterDiscount * 0.07 : 0;
                                              const totalPrice = priceAfterDiscount + vat;

                                              return {
                                                totalItemPrice: acc.totalItemPrice + detail.Item_Total,
                                                totalDiscount: acc.totalDiscount + discountValue,
                                                totalPriceAfterDiscount: acc.totalPriceAfterDiscount + priceAfterDiscount,
                                                totalVat: acc.totalVat + vat,
                                                grandTotal: acc.grandTotal + totalPrice,
                                              };
                                            },
                                            {
                                              totalItemPrice: 0,
                                              totalDiscount: 0,
                                              totalPriceAfterDiscount: 0,
                                              totalVat: 0,
                                              grandTotal: 0,
                                            }
                                          );

                                        return (
                                          <div
                                            className="card mt-4 p-4"
                                            style={{
                                              backgroundColor: "#ffffff",
                                              marginLeft: "25px",
                                              border: "1px solid #ddd",
                                              borderRadius: "12px",
                                              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                                            }}
                                          >
                                            <h5
                                              style={{
                                                marginBottom: "1rem",
                                                color: "#EF6C00",
                                                fontWeight: "bold",
                                                borderBottom: "2px solid #ddd",
                                                paddingBottom: "0.5rem",
                                                fontSize: "1.2rem",  // เพิ่มขนาดตัวอักษรให้โดดเด่นขึ้น
                                              }}
                                            >
                                              ผลรวมรายการสินค้า
                                            </h5>
                                            <div
                                              className="d-flex justify-content-between align-items-center mb-2"
                                              style={{
                                                padding: "0.3rem 0",
                                                fontSize: "1rem",  // ขนาดตัวอักษรพอดี
                                                color: "#333",
                                              }}
                                            >
                                              <span><strong>รวมราคา:</strong></span>
                                              <span>{formatCurrency(totals.totalItemPrice)} ฿</span>
                                            </div>
                                            <div
                                              className="d-flex justify-content-between align-items-center mb-2"
                                              style={{
                                                padding: "0.3rem 0",
                                                fontSize: "1rem",
                                                color: "#333",
                                              }}
                                            >
                                              <span><strong>รวมส่วนลด:</strong></span>
                                              <span>{formatCurrency(totals.totalDiscount)} ฿</span>
                                            </div>
                                            <div
                                              className="d-flex justify-content-between align-items-center mb-2"
                                              style={{
                                                padding: "0.3rem 0",
                                                fontSize: "1rem",
                                                color: "#333",
                                              }}
                                            >
                                              <span><strong>ราคาหลังหักส่วนลด:</strong></span>
                                              <span>{formatCurrency(totals.totalPriceAfterDiscount)} ฿</span>
                                            </div>
                                            <div
                                              className="d-flex justify-content-between align-items-center mb-2"
                                              style={{
                                                padding: "0.3rem 0",
                                                fontSize: "1rem",
                                                color: "#333",
                                              }}
                                            >
                                              <span><strong>VAT (7%):</strong></span>
                                              <span>{formatCurrency(totals.totalVat)} ฿</span>
                                            </div>
                                            <div
                                              className="mt-3 text-center"
                                              style={{
                                                backgroundColor: "#1E90FF", // เปลี่ยนสีพื้นหลังให้ดูสะดุดตา
                                                color: "#fff",
                                                padding: "0.8rem",
                                                borderRadius: "8px",
                                                fontSize: "1.3rem",  // ขนาดฟอนต์ที่พอดี
                                                fontWeight: "bold",
                                                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",  // เพิ่มเงาให้ดูน่าสนใจ
                                              }}
                                            >
                                              รวมทั้งสิ้น: {formatCurrency(totals.grandTotal)} ฿
                                            </div>
                                          </div>
                                        );
                                      })()}
                                    </>
                                  ) : (
                                    <div className="text-center text-muted">
                                      <p>ไม่มีรายการสินค้า</p>
                                    </div>
                                  )}
                                </details>
                              </div>


                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <div className="text-center">
                        <h5 className="text-muted">ไม่พบรายการขาย</h5>
                      </div>
                    )}
                  </>
                )}

                {activeTab === "stockRemaining" && (
                  <>
                    <div className="card-header d-flex justify-content-between align-items-center">
                      <h4 className="card-title mb-0">สินค้าคงเหลือ</h4>
                    </div>
                    <div className="card-body">
                      <div
                        className="table-responsive"
                        style={{ maxHeight: "500px", overflowY: "auto" }}
                      >
                        <table
                          id="basic-datatables"
                          className="table table-striped table-hover"
                        >
                          <thead className="thead-dark">
                            <tr>
                              <th
                                className="text-center"
                                style={{ width: "10%" }}
                              >
                                รหัสสินค้า
                              </th>
                              <th
                                className="text-center"
                                style={{ width: "50%" }}
                              >
                                ชื่อสินค้า
                              </th>
                              <th
                                className="text-center"
                                style={{ width: "10%" }}
                              >
                                คงเหลือ
                              </th>
                              <th
                                className="text-center"
                                style={{ width: "15%" }}
                              >
                                หน่วย
                              </th>
                              <th
                                className="text-center"
                                style={{ width: "15%" }}
                              >
                                วันที่ทำรายการล่าสุด
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {formItemOnHandCaseTab.length > 0 ? (
                              formItemOnHandCaseTab.map((item, index) => (
                                <tr key={item.Item_Id || index + 1}>
                                  <td className="text-center">
                                    {item.Item_Code}
                                  </td>
                                  <td className="text-left">
                                    {item.Item_Name}
                                  </td>
                                  <td className="text-center">
                                    {item.Item_Onhand}
                                  </td>
                                  <td className="text-center">
                                    {item.Item_Unit_ST}
                                  </td>
                                  <td className="text-center">
                                    {item.Last_STC_Date
                                      ? formatDate(item.Last_STC_Date)
                                      : ""}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={10}>
                                  <center>
                                    <h5>
                                      {formMasterList.pkCarId === ""
                                        ? "กรุณาเลือก รถส่งสินค้า ก่อน"
                                        : "ไม่พบรายการสินค้าคงเหลือ"}
                                    </h5>
                                  </center>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </>
                )}

                {activeTab === "withdraw" && (
                  <>
                    <div className="card-header justify-content-between align-items-center">
                      <div className="row">
                        <div className="col-4">
                          <h4 className="card-title">รายการนำเข้า</h4>
                        </div>
                        <div className="col-8 d-flex justify-content-end">
                          <button
                            type="button"
                            className="btn btn-success mr-2"
                            hidden={formItemWithdrawCaseTab.length < 1}
                            onClick={() => handleConfirmImport()}
                            disabled={onLoadConfirm}
                          >
                            <i className="fa fa-check"></i>{" "}
                            ยืนยันการนำเข้าสินค้า
                          </button>

                          <button
                            className="btn text-white mx-3"
                            onClick={handleImportShow}
                            style={{
                              backgroundColor: "rgb(239, 108, 0)",
                              whiteSpace: "nowrap",
                              padding: "10px",
                              fontSize: "15px",
                            }}
                            disabled={
                              mode !== "U" ||
                              selectedType === "" ||
                              formMasterList.docStatus !== 1
                            }
                          >
                            <i className="fa fa-plus"></i> นำเข้าสินค้า
                          </button>
                        </div>
                      </div>
                      {showImportModal && (
                        <ImportModal
                          onConfirmImportSelection={onConfirmImportSelection}
                          showImportModal={showImportModal}
                          handleImportClose={handleImportClose}
                          name={name}
                          pickingList={formMasterList}
                          selectedImports={selectedImports}
                        />
                      )}
                    </div>
                    <div className="card-body">
                      <TeasuryTable dataList={formItemWithdrawCaseTab} />
                    </div>
                    <div className="card-footer">
                      <button
                        type="button"
                        className="btn btn-danger"
                        hidden={formItemWithdrawCaseTab.length < 1}
                        onClick={() => handleRemoveFormWd()}
                        disabled={onLoadConfirm}
                      >
                        <i className="fa fa-times"></i> ยกเลิกการนำเข้าสินค้า
                      </button>
                    </div>
                  </>
                )}
              </div>

              {showViewSoModal && selectedSoData && (
                <ViewSoModal
                  showViewSoModal={showViewSoModal}
                  handleViewSoClose={handleViewSoClose} // ใช้ฟังก์ชันปิด Modal
                  mode={"U"}
                  name={`ใบขายสินค้าเลขที่ ${selectedSoData.Doc_No}`}
                  maxDocNo={selectedSoData.Doc_No} // ส่งหมายเลขใบขาย
                />
              )}
            </div>
          </div>
        </div>
        <div className="row mt-5">
          <div
            className="col-3"
            style={{ borderRight: "2px solid #c7c8c9" }}
          ></div>
          {/* <div className="col-9">
          <Summary
            formMasterList={formMasterList}
            handleChangeMaster={handleChangeMaster}
            selectedDiscountValueType={selectedDiscountValueType}
            handleCheckboxChange={handleCheckboxChange}
            receiptDiscount={receiptDiscount}
            formatCurrency={formatCurrency}
            totalPrice={totalPrice}
            subFinal={subFinal}
            isVatChecked={isVatChecked}
            handleVatChange={handleVatChange}
            vatAmount={vatAmount}
            grandTotal={grandTotal}
            disabled={false}
          />
        </div> */}
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <FormAction
            onSubmit={handleSubmit}
            onUpdate={handleUpdate}
            onCancel={handleCancel}
            mode={mode}
            disabled={formMasterList.docStatus === 1 ? false : true}
            footer={true}
          />
        </div>
      </div>
    </>
  );
}

export default Form;
